const translations = {
  en: {
    clickIfControlNumber: 'Click here if you have a',
    controlNumberLabel: 'Control Number',
    requestedReceivers: 'My Requested Receivers:',
    tnxId: 'Tnx ID',
    receiver: 'Receiver',
    amount: 'Amount',
    address: 'Address',
    controlNumber: 'Control Number:',
    controlNumberPlaceholder: 'Control Number',
    controlNumberRequired: 'Control number required.',
    complete: 'Complete',
    amountLabel: 'Amount',
    amountPlaceholder: 'Amount',
    currency: 'Currency',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    secondName: 'Second name (Optional)',
    secondLastName: 'SecondLastName',
    alias: 'Alias:',
    pleaseChoose: '- Please Choose -',
    country: 'Country',
    stateProv: 'State / Prov',
    city: 'City',
    phone: 'Phone',
    validity72h: 'Please note your person to person instructions will be valid for next 72 hours, after this time you will have to request new ones.',
    back: 'BACK',
    getNewInstructions: 'GET NEW INSTRUCTIONS',
    warning: 'Warning',
    error: 'Error',
    controlNumberRequiredAlert: 'Control Number required',
    depositStatus: 'Deposit Status',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    clickIfControlNumber: 'Haga clic aquí si tiene un',
    controlNumberLabel: 'Número de Control',
    requestedReceivers: 'Mis Beneficiarios Solicitados:',
    tnxId: 'ID Trx',
    receiver: 'Beneficiario',
    amount: 'Monto',
    address: 'Dirección',
    controlNumber: 'Número de Control:',
    controlNumberPlaceholder: 'Número de Control',
    controlNumberRequired: 'Número de control requerido.',
    complete: 'Completar',
    amountLabel: 'Monto',
    amountPlaceholder: 'Monto',
    currency: 'Moneda',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    name: 'Nombre',
    firstName: 'Nombre',
    lastName: 'Apellido',
    secondName: 'Segundo nombre (Opcional)',
    secondLastName: 'Segundo Apellido',
    alias: 'Alias:',
    pleaseChoose: '- Por favor Elija -',
    country: 'País',
    stateProv: 'Estado / Provincia',
    city: 'Ciudad',
    phone: 'Teléfono',
    validity72h: 'Por favor tenga en cuenta que sus instrucciones de persona a persona serán válidas por las próximas 72 horas, después de este tiempo tendrá que solicitar nuevas.',
    back: 'ATRÁS',
    getNewInstructions: 'OBTENER NUEVAS INSTRUCCIONES',
    warning: 'Advertencia',
    error: 'Error',
    controlNumberRequiredAlert: 'Número de Control requerido',
    depositStatus: 'Estado del Depósito',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    clickIfControlNumber: 'Clique aqui se você tem um',
    controlNumberLabel: 'Número de Controle',
    requestedReceivers: 'Meus Destinatários Solicitados:',
    tnxId: 'ID Trx',
    receiver: 'Destinatário',
    amount: 'Valor',
    address: 'Endereço',
    controlNumber: 'Número de Controle:',
    controlNumberPlaceholder: 'Número de Controle',
    controlNumberRequired: 'Número de controle obrigatório.',
    complete: 'Completar',
    amountLabel: 'Valor',
    amountPlaceholder: 'Valor',
    currency: 'Moeda',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    name: 'Nome',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    secondName: 'Segundo nome (Opcional)',
    secondLastName: 'Segundo Sobrenome',
    alias: 'Apelido:',
    pleaseChoose: '- Por favor Escolha -',
    country: 'País',
    stateProv: 'Estado / Província',
    city: 'Cidade',
    phone: 'Telefone',
    validity72h: 'Por favor note que suas instruções de pessoa para pessoa serão válidas pelas próximas 72 horas, após este período você terá que solicitar novas.',
    back: 'VOLTAR',
    getNewInstructions: 'OBTER NOVAS INSTRUÇÕES',
    warning: 'Aviso',
    error: 'Erro',
    controlNumberRequiredAlert: 'Número de Controle obrigatório',
    depositStatus: 'Status do Depósito',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
